/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IIntegrationChannel } from 'app/shared/model/integration-channel.model';

export interface IIntegrationEndpoint {
  id?: string;
  name?: string | null;
  description?: string | null;
  uri?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  authType?: IClinicalDictionary | null;
  protocol?: IClinicalDictionary | null;
  httpServiceType?: IClinicalDictionary | null;
  method?: IClinicalDictionary | null;
  channel?: IIntegrationChannel | null;
}

export const defaultValue: Readonly<IIntegrationEndpoint> = {
  active: false,
};
